module.exports = __webpack_public_path__ + "img/no_data_found.4084d441.svg";